package com.vamvisions.main.components.background

import androidx.compose.runtime.Stable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.runtime.staticCompositionLocalOf

/**
 * Per-visit state shared by [IntroBackground] and the Home page. It lives in the app shell, so it survives in-app
 * navigation and resets on reload. [introFinished] turns true once the intro video ends or is skipped: poster
 * fallback, reduced motion or a colour scheme change. [homeRevealPlayed] turns true once the Home reveal has started
 * or been skipped, so it never replays.
 */
@Stable
class IntroState {
    var introFinished by mutableStateOf(false)
    var homeRevealPlayed by mutableStateOf(false)
}

val LocalIntroState = staticCompositionLocalOf<IntroState> { error("No IntroState provided") }
